import { Record, Map as ImmutableMap, List } from 'immutable';
import getIn from 'immutable-less/transmute/getIn';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import TimeDelay from 'automation-ui-flow-core/fields/time/TimeDelay';
import * as ChronoUnit from 'automation-ui-flow-core/fields/time/ChronoUnit';
import * as EventFilterKeys from 'automation-ui-action-features/actions/wait-until/constants/EventFilterKeys';
import * as WaitUntilActionMetadataKeys from 'automation-ui-action-features/actions/wait-until/constants/WaitUntilActionMetadataKeys';
import EventFilter from 'automation-ui-enrollment/records/EventFilter';
export const DEFAULT_EXPIRATION_DELTA = 7200; // 5 days in minutes

export default class WaitUntilActionMetadata extends Record({
  [WaitUntilActionMetadataKeys.ACTION_TYPE]: ActionTypes.WAIT_UNTIL,
  [WaitUntilActionMetadataKeys.EVENT_FILTERS]: null,
  [WaitUntilActionMetadataKeys.EXPIRATION]: null,
  [WaitUntilActionMetadataKeys.TARGET_OBJECT_OVERRIDE]: null,
  [WaitUntilActionMetadataKeys.CONTINUE_IF_EVENT_HAS_ALREADY_OCCURRED]: false
}, 'WaitUntilActionMetadata') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    const expiration = propMap.get(WaitUntilActionMetadataKeys.EXPIRATION) || {
      delta: DEFAULT_EXPIRATION_DELTA,
      timeUnit: ChronoUnit.MINUTES
    };
    const eventFiltersArr = propMap.get(WaitUntilActionMetadataKeys.EVENT_FILTERS) || [];
    const eventFilters = List(eventFiltersArr.map(eventFilter => new EventFilter(eventFilter)));
    super(propMap.set(WaitUntilActionMetadataKeys.EXPIRATION, new TimeDelay(expiration)).set(WaitUntilActionMetadataKeys.EVENT_FILTERS, eventFilters));
  }
  getEventFilters() {
    return this[WaitUntilActionMetadataKeys.EVENT_FILTERS];
  }
  getEventFiltersToDisplay() {
    const eventFilters = this[WaitUntilActionMetadataKeys.EVENT_FILTERS];
    return eventFilters !== null ? eventFilters.filter(eventFilter => eventFilter.getUpdateType() !== EventFilterKeys.DELETE) : List();
  }
  getExpiration() {
    return this[WaitUntilActionMetadataKeys.EXPIRATION];
  }
  getTargetActionId() {
    return getIn([WaitUntilActionMetadataKeys.TARGET_OBJECT_OVERRIDE, 'identifier', 'actionId'], this);
  }
  setEventFilters(eventFilters) {
    return this.set(WaitUntilActionMetadataKeys.EVENT_FILTERS, eventFilters);
  }
  hasEmptyEventFilters() {
    const eventFilters = this.getEventFilters();
    if (eventFilters === null) {
      return false;
    }
    if (eventFilters.size === 0) {
      return true;
    }
    return eventFilters.some(eventFilter => {
      const innerEventFilter = eventFilter.getEventFilter();
      const hasUnifiedEventFilter = Boolean(eventFilter.getEventTypeMetaType() && eventFilter.getEventTypeInnerId());
      return !innerEventFilter || !hasUnifiedEventFilter || eventFilter.getUpdateType() === EventFilterKeys.DELETE;
    });
  }
  getContinueIfEventHasAlreadyOccurred() {
    return this[WaitUntilActionMetadataKeys.CONTINUE_IF_EVENT_HAS_ALREADY_OCCURRED];
  }
  setContinueIfEventHasAlreadyOccurred(value) {
    return this.set(WaitUntilActionMetadataKeys.CONTINUE_IF_EVENT_HAS_ALREADY_OCCURRED, value);
  }
}